module.exports = __webpack_public_path__ + "img/mgh-fukuoka-nakasu.092f8a9c.jpg";